import { useTranslation } from 'react-i18next'

import { CredentialField, CredentialsCardProps, CredentialsFormCard } from './credentials-form-card'
import { useIglooWorkCredentials, useSaveIglooWorkCredentials } from './provider-connections'

export const IglooWorkCard = ({ buildingId, ...props }: CredentialsCardProps) => {
  const { t } = useTranslation(['organisation'])
  const { clientId, config, configured, isLoading } = useIglooWorkCredentials(buildingId)
  const { isPending, mutateAsync: save } = useSaveIglooWorkCredentials()

  const fields: CredentialField[] = [
    {
      error: t('organisation:places.integrations.iglooWork.errors.clientId'),
      label: t('organisation:places.integrations.iglooWork.fields.clientId.label'),
      name: 'clientId',
      placeholder: t('organisation:places.integrations.iglooWork.fields.clientId.placeholder'),
    },
    {
      error: t('organisation:places.integrations.iglooWork.errors.clientSecret'),
      label: t('organisation:places.integrations.iglooWork.fields.clientSecret.label'),
      name: 'clientSecret',
      placeholder: t('organisation:places.integrations.iglooWork.fields.clientSecret.placeholder'),
      secret: true,
    },
  ]

  return (
    <CredentialsFormCard
      {...props}
      configured={configured}
      fields={fields}
      isLoading={isLoading}
      isSaving={isPending}
      savedValues={{ clientId }}
      onSave={(values) =>
        save({ buildingId, clientId: values.clientId, clientSecret: values.clientSecret, config })
      }
    />
  )
}
